import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.68,28.23c-1.77,10.76-10.57,18.97-21.42,20l-12-12.46l-2.13-2.22l0,0l1.6-1.21l5.53-4.29l2.37-1.83
l4.74-3.68l2.37-1.83l0.74-0.58l1-0.76l1.26-1l1.59-1.23l1-0.74l1.58-1.23L47.68,28.23z"
  />
);

const HalAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_8}
    renderShadow={renderShadow}
  >
    <>
      <circle style={{ fill: '#A0A0A0' }} cx="24" cy="24.34" r="15" />
      <circle style={{ fill: '#333333' }} cx="24" cy="24.34" r="13" />
      <circle style={{ fill: '#ED652F' }} cx="24" cy="24.34" r="6" />
      <circle style={{ fill: '#FFE8A9' }} cx="24" cy="24.34" r="3" />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M29,14.34c-0.16,0.35-1.34,0-5,0s-4.84,0.35-5,0s1.58-2,5-2S29.19,13.92,29,14.34z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M27,16.97c-0.09,0.21-0.8,0-3,0s-2.9,0.21-3,0s0.94-1.2,3-1.2S27.11,16.72,27,16.97z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M14.13,17.34c-1,1.68-0.63,3.89-0.13,4c0.33,0.07,0.84-0.95,1.87-3c0.92-1.85,1.38-2.78,1.13-3
	S15,15.89,14.13,17.34z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M17.47,18.62c-0.56,1-0.37,2.3-0.08,2.36s0.5-0.56,1.1-1.77s0.82-1.64,0.67-1.77S18,17.77,17.47,18.62z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M33.45,17.34c1,1.68,0.63,3.89,0.14,4c-0.33,0.07-0.85-0.95-1.87-3c-0.92-1.85-1.38-2.78-1.13-3
	S32.63,15.89,33.45,17.34z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M30.17,18.58c0.62,1.09,0.41,2.53,0.08,2.61s-0.55-0.62-1.21-2s-0.9-1.81-0.74-1.95S29.63,17.64,30.17,18.58z"
      />
    </>
  </AvatarArtwork>
);

export default HalAvatarArtwork;
